import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  padding: 8px 0px;
  flex-direction: row;
  justify-content: space-between;
`;
